<template>
  <div id="resize_iframe">
    <EntryPage
      v-if="isShowEntryPage()"
      :getDatetimeString="getDatetimeString"
      :formatNumberByStep="formatNumberByStep"
      :commonSetting="commonSetting"
      :groupName="groupName"
      :encryptJobCode="encryptJobCode"
      :hash="log.hash"
      @createLogger="createLogger($event)"
      :resourcesAPI="resourcesAPI"
      :TYPE_OF_SINGLE_SELECT="TYPE_OF_SINGLE_SELECT"
      :TYPE_OF_MULTI_SELECT="TYPE_OF_MULTI_SELECT"
      :FORMAT_DATE="FORMAT_DATE"
      :TYPE_OF_NUMBER="TYPE_OF_NUMBER"
      @syncCheckDisplayPrint="checkAllowDisplay($event)"
      :isDisplayPrint="isDisplayPrint"
      @printPage="printPage"
    />
    <SearchJobPage
      v-if="isShowJobSearchPage()"
      :getDatetimeString="getDatetimeString"
      :formatNumberByStep="formatNumberByStep"
      :isPreviousItemHaveData="isPreviousItemHaveData"
      :isObjectDataHasValue="isObjectDataHasValue"
      :encryptJobCode="encryptJobCode"
      :groupName="groupName"
      :commonSetting="commonSetting"
      :hash="log.hash"
      v-on:createLogger="createLogger($event)"
      :resourcesAPI="resourcesAPI"
      :TYPE_OF_SINGLE_SELECT="TYPE_OF_SINGLE_SELECT"
      :TYPE_OF_MULTI_SELECT="TYPE_OF_MULTI_SELECT"
      :FORMAT_DATE="FORMAT_DATE"
      :TYPE_OF_NUMBER="TYPE_OF_NUMBER"
      @syncCheckDisplayPrint="checkAllowDisplay($event)"
      :isDisplayPrint="isDisplayPrint"
      @printPage="printPage"
    />
    <DetailJobPage
      v-if="isShowJobDetail()"
      :getDatetimeString="getDatetimeString"
      :formatNumberByStep="formatNumberByStep"
      :isPreviousItemHaveData="isPreviousItemHaveData"
      :isObjectDataHasValue="isObjectDataHasValue"
      :encryptJobCode="encryptJobCode"
      :encryptEntryCode="encryptEntryCode"
      :groupName="groupName"
      :commonSetting="commonSetting"
      :hash="log.hash"
      v-on:createLogger="createLogger($event)"
      :TYPE_OF_SINGLE_SELECT="TYPE_OF_SINGLE_SELECT"
      :TYPE_OF_MULTI_SELECT="TYPE_OF_MULTI_SELECT"
      :FORMAT_DATE="FORMAT_DATE"
      :TYPE_OF_NUMBER="TYPE_OF_NUMBER"
      @syncCheckDisplayPrint="checkAllowDisplay($event)"
      :isDisplayPrint="isDisplayPrint"
      @printPage="printPage"
    />
    <DetailDispatchJobPage
      v-if="isShowDetailDispatchJobPage()"
      :getDatetimeString="getDatetimeString"
      :formatNumberByStep="formatNumberByStep"
      :isPreviousItemHaveData="isPreviousItemHaveData"
      :isObjectDataHasValue="isObjectDataHasValue"
      :encryptJobCode="encryptJobCode"
      :encryptEntryCode="encryptEntryCode"
      :groupName="groupName"
      :commonSetting="commonSetting"
      :hash="log.hash"
      v-on:createLogger="createLogger($event)"
      :resourcesAPI="resourcesAPI"
      :TYPE_OF_SINGLE_SELECT="TYPE_OF_SINGLE_SELECT"
      :TYPE_OF_MULTI_SELECT="TYPE_OF_MULTI_SELECT"
      :FORMAT_DATE="FORMAT_DATE"
      :TYPE_OF_NUMBER="TYPE_OF_NUMBER"
      @syncCheckDisplayPrint="checkAllowDisplay($event)"
      :isDisplayPrint="isDisplayPrint"
      @printPage="printPage"
    />
<!--    <div class="setting_botton_top" ref="ref_botton_top">-->
<!--      <button class="setting_btn_primary" @click="onTopPage">-->
<!--        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em"><path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"></path></svg>-->
<!--      </button>-->
<!--    </div>-->
<!--    <div class="setting_btn_print" v-if="isDisplayPrint">-->
<!--      <button class="setting_btn_primary" @click="printPage()">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>-->
<!--      </button>-->
<!--    </div>-->
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import GeneralPageProperties from "../../properties/general_page/generalpage.json";
import commonSettingsProperties from "../../properties/common_screen/common-settings.json";
import commonSettingsService from "../../services/CommonSettingsService";
import EntryPage from "./EntryPage";
import SearchJobPage from "./SearchJobPage";
import DetailJobPage from "./DetailJobPage";
import DetailDispatchJobPage from "./DetailDispatchJobPage";
import generalService from "../../services/GeneralService";
import {Encrypt } from "@/plugins/cryptojs";
import moment from "moment";
import { getGroupName } from '../../util/SystemUtil'
Vue.use(VueRouter);

const ENTRY_TEXT = "entry";
const JOB_TEXT = "job";
const DETAIL_FORM_TYPE = 2;
const DISPATCH_DETAIL_FORM_TYPE = 6;

export default {
  name: "UserBasePage",
  components: {
    EntryPage: EntryPage,
    SearchJobPage: SearchJobPage,
    DetailJobPage: DetailJobPage,
    DetailDispatchJobPage: DetailDispatchJobPage
  },
  data() {
    return {
      groupName: "",
      commonSetting: {},
      properties: GeneralPageProperties,
      encryptEntryCode: "",
      encryptJobCode: "",
      accessAnalysisSettings: [],
      log: {
        hash: "",
        info: {},
      },
      resourcesAPI: commonSettingsProperties.RESOURCE_API,
      TYPE_OF_SINGLE_SELECT: commonSettingsProperties.TYPE_OF_SINGLE_SELECT,
      TYPE_OF_MULTI_SELECT: commonSettingsProperties.TYPE_OF_MULTI_SELECT,
      TYPE_OF_NUMBER: commonSettingsProperties.TYPE_OF_NUMBER,
      FORMAT_DATE: commonSettingsProperties.FORMAT_DATE,
      isDisplayPrint: false
    };
  },
  async created() {
    this.groupName = getGroupName();
    this.encryptEntryCode = Encrypt(this.groupName + ENTRY_TEXT);
    this.encryptJobCode = Encrypt(this.groupName + JOB_TEXT);
    this.validateParamValue();

    await this.createLogger("Get data setting");
    await this.getCommonSetting(this.log.hash);
    let header = document.getElementsByTagName("head")[0];
    let body = document.getElementsByTagName("body")[0];
    this.accessAnalysisSettings.filter(ass => ass && ass.accessAnalysis).forEach((accessAnalysisSetting) => {
      const position = accessAnalysisSetting.introductionPoint === 0 ? "head" : "body";
      let script = document.createElement('script');
      script.type = "text/javascript";
      const regexScript = /<script\s*.*>(.*?)<\/script>/gmi;
      let contentScripts = regexScript.exec(accessAnalysisSetting.accessAnalysis.replace(/\r?\n/g, ""));
      let content = "";
      if(contentScripts && Array.isArray(contentScripts) && contentScripts.length > 0){
        contentScripts.filter(sc => sc && !sc.endsWith('script>')).forEach(sc => {
          content += sc;
        });
        script.appendChild(document.createTextNode(content));
        if(position === "head"){
          header.appendChild(script);
        }else{
          body.appendChild(script);
        }
      } else {
        if(position === "head"){
          header.insertAdjacentHTML("beforeEnd", accessAnalysisSetting.accessAnalysis);
        }else{
          body.insertAdjacentHTML("beforeEnd", accessAnalysisSetting.accessAnalysis);
        }
      }
    });

    // document.body.addEventListener('scroll', (e)=> {
    //   if(this.$refs.ref_botton_top){
    //     this.$refs.ref_botton_top.style.display = "none";
    //     if(e.target.scrollTop > 20) {
    //       this.$refs.ref_botton_top.style.display = "block";
    //     }
    //   }
    // })
  },
  methods: {
    checkAllowDisplay(value){
      this.isDisplayPrint = value ? value: false;
    },

    printPage(){
      window.print();
    },

    isObjectDataHasValue(value){
      if(!value) return false;
      return (typeof value === 'object' && value && value.data);
    },

    formatNumberByStep(value, step) {
      if(!value || Number.isNaN(Number(value))) return value;
      if(!step || step === 1) return Number(value).toLocaleString();
      step = String(step);
      value = String(value);
      let sIdx = (step.indexOf('.') > -1) ? step.substr(step.indexOf('.') + 1).length : 0;
      const nIdx = (value.indexOf('.') > -1) ? value.substr(value.indexOf('.') + 1).length : 0;
      if(sIdx <= 0 || nIdx <= 0)
        return Number(value).toLocaleString(undefined, { maximumFractionDigits: sIdx });
      const vs = value.split('.');
      let nv1 = Number(vs[0]).toLocaleString();
      let nv2 = vs[1];
      if(sIdx > nIdx) {
        sIdx = sIdx - nv2.length;
        nv2 += Array.from('0'.repeat(sIdx)).join('');
      } else {
        nv2 = nv2.substr(0, sIdx);
      }
      return nv1 + '.' + nv2;
    },

    async getCommonSetting(hash, encryptEntryCode) {
      await commonSettingsService
        .getCommonSetting(hash, encryptEntryCode)
        .then((response) => {
          if (response.data.id !== null) {
            this.commonSetting = response.data;
            this.accessAnalysisSettings = response.data.accessAnalysisSettings
          } else {
            this.$router.push("/404");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$router.push("/404");
        });
    },

    validateParamValue() {
      if (
        this.$router.currentRoute.query.c === "" ||
        (this.$router.currentRoute.query.c !== this.encryptEntryCode &&
          this.$router.currentRoute.query.c !== this.encryptJobCode)
      ) {
        this.$router.push("/404");
      }
    },

    isShowEntryPage() {
      return (
        this.$route.query.c === this.encryptEntryCode &&
        this.commonSetting.entryPublic
      );
    },

    isShowJobSearchPage() {
      return (
        this.$route.query.c === this.encryptJobCode &&
        this.$route.query.jid === undefined &&
        this.commonSetting.jobSearchPublic
      );
    },

    isShowJobDetail() {
      return (
        this.$route.query.c === this.encryptJobCode &&
        this.$route.query.jid &&
        this.commonSetting.jobSearchPublic && 
        Number(this.$route.query.jt) === DETAIL_FORM_TYPE
      );
    },

    isShowDetailDispatchJobPage(){
      return (
        this.$route.query.c === this.encryptJobCode &&
        this.$route.query.jid &&
        this.commonSetting.jobSearchPublic && 
        Number(this.$route.query.jt) === DISPATCH_DETAIL_FORM_TYPE
      );
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService
        .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
        .then((response) => {
          if (response.status === 200) {
            return true;
          }
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      await this.sendLogger(this.log);
    },

    onTopPage() {
      document.body.scrollTop = 0;
    },

    isPreviousItemHaveData(jobDetail, key, index, firtKey, items) {
      if (index === 0) {
        return false;
      }

      let value = jobDetail[key];
      let ks = key ? key.split('.') : [];
      if (ks.length > 1) {
        let values = jobDetail[ks[0]];
        if(Array.isArray(values)) {
          let vs = [];
          values.forEach(f => {
            vs.push(f[ks[1]]);
          });
          value = vs.filter(Boolean).join();
        } else {
          value = jobDetail[ks[0]] ? jobDetail[ks[0]][ks[1]]: "";
        }
      }
      if(index >= 1 && value){
        let firtValue = this.getBeforeValueItem(jobDetail, index, items);
        return (firtValue!==null && firtValue!=='' && value!==null && value!=='');
      }
      return (value!==null && value!=='');
    },

    getBeforeValueItem(job, index, items){
      let value = "";
      for (let i = (index - 1); i >= 0; i--) {
        const item = items[i];
        if(!item || !item.name) continue;
        let firtks = item.name ? item.name.split('.') : [];
        if (firtks.length > 1) {
          let values = job[firtks[0]];
          if(Array.isArray(values)) {
            let vs = [];
            values.forEach(f => {
              vs.push(f[firtks[1]]);
            });
            value = vs.filter(Boolean).join();
          } else {
            value = job[firtks[0]] ? job[firtks[0]][firtks[1]]: "";
          }
        }else{
          value = job[firtks[0]];
        }
        if(value) break; 
      }
      return value;
    },

    getDatetimeString(type, value) {
      if(value===null || value==='') return '';
      let patern = 'yyyy/MM/DD HH:mm';
      if(type==='date') patern = 'yyyy/MM/DD';
      if(type==='ym') patern = 'yyyy/MM';
      if(type==='time') patern = 'HH:mm';

      if(value.default_value_from || value.default_value_to){
        let valueFrom = value.default_value_from ? moment(value.default_value_from).format(patern): "";
        let valueTo = value.default_value_to ? moment(value.default_value_to).format(patern): "";
        return valueFrom + " ~ " + valueTo;
      }else{
        let valueDateTime = value.default_value ? value.default_value: value;
        if(type === 'time' && typeof value === 'string'){
          return value.substring(0,5);
        }else{
          return moment(valueDateTime).format(patern);
        }
      }
    }
  },
};
</script>

<style lang="css" scoped>
.jobs_wrapper {
  max-width: unset !important;
}
.setting_botton_top{
  position: absolute;
  bottom: calc(100vh/4);
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: none;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}
.setting_btn_print{
  position: absolute;
  top: 0px;
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: block;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}
</style>
